module.exports = "/_next/static/images/CompleteDataCollected-82e2b28b0c33183b945d84458c6e05b7.webp";